/**
 * 从 URL path 推算 contant.js 中的 key（即原路由 name）
 *
 * URL path 末段（如 face_detection）→ contant.js key（如 FaceDetection / faceAge）
 * 由于历史原因 key 格式并不统一，这里维护一个映射表
 */

// path 末段 → contant.js key 映射
const pathToKeyMap = {
  // recognition_general
  face_detection: 'FaceDetection',
  face_landmarks_detection: 'Landmarks',
  face_age: 'faceAge',
  face_gender: 'faceGender',
  face_emotion: 'faceEmotion',
  body_detection: 'bodyDetection',
  body_keypoint: 'bodyKeypoint',
  body_attribute: 'bodyAttribute',
  qr_code: 'qrCode',
  ocr_vehicle_plate: 'ocrVehiclePlate',
  vehicle_detection: 'vehicleDetection',
  body_human_segmentation: 'bodyHumanSegmentation',
  body_detection_smoking: 'bodyDetectionSmoking',
  body_hand_keypoint: 'bodyHandKeypoint',
  body_crowd_density: 'bodyCrowdDensity',
  face_mask_detection: 'faceMaskDetection',
  body_helmet_detection: 'bodyHelmetDetection',
  body_head_shoulder_detection: 'bodyHeadShoulderDetection',
  detection_fire: 'detectionFire',
  classification_general: 'classificationGeneral',
  classification_animal: 'classificationAnimal',
  classification_vegetables: 'classificationVegetables',
  classification_vehicle_type: 'classificationVehicleType',
  classification_dishes: 'classificationDishes',
  classification_landmark: 'classificationLandmark',
  body_reflective_vest_detection: 'bodyReflectiveVestDetection',
  body_gesture_recognition: 'bodyGestureRecognition',
  ocr_water_meter: 'ocrWaterMeter',

  // common_algorithm
  body_driver_monitoring: 'bodyDriverMonitoring',
  ocr_business_license: 'ocrBusinessLicense',
  ocr_bank_card: 'ocrBankCard',
  ocr_invoice_information: 'ocrInvoiceInformation',
  ocr_driver_license: 'ocrDriverLicense',
  face_photo_clustering: 'facePhotoClustering',
  face_appearance_level: 'faceAppearanceLevel',
  body_fight_recognition: 'bodyFightRecognition',
  ocr_table: 'ocrTable',
  detection_smoke: 'detectionSmoke',
  detection_animal: 'detectionAnimal',
  image_tech_product_search: 'imageTechProductSearch',
  image_tech_elimination: 'imageTechElimination',
  image_tech_defogging: 'imageTechDefogging',
  image_tech_color_enhancement: 'imageTechColorEnhancement',
  image_tech_generation: 'imageTechGeneration',
  image_tech_style_transfer: 'imageTechStyleTransfer',

  // face_comparison
  face_comparison: 'faceComparison',
  pet_comparison: 'petComparison',

  // ocr_general
  ocr_general: 'ocrGeneral',
  ocr_handwritten: 'ocrHandwritten',

  // recognition_slide
  image_tech_super_resolution: 'imageTechSuperResolution',
  image_tech_anime: 'imageTechAnime',
  image_tech_coloring: 'imageTechColoring',
  image_tech_depth_estimation: 'imageTechDepthEstimation',

  // text_image
  text_image: 'textImage',
  image_search: 'imageSearch',

  // audio_denoising
  audio_denoising: 'audioDenoising',
  audio_echo_cancellation: 'audioEchoCancellation',

  // voice_wakeup
  voice_wake_up: 'voiceWakeUp',
  voice_synthesis: 'voiceSynthesis',

  // video_general
  motion_image: 'motionImage',
  image_tech_odd_coincidence_frame: 'imageTechOddCoincidenceFrame',

  // image_understanding
  image_understanding: 'imageUnderstanding',

  // language_model
  language_model: 'languageModel',
}

/**
 * 根据路由 path 获取 contant.js 中对应的 key
 * @param {import('vue-router').RouteLocationNormalized} route
 * @returns {string} contant.js 中的 key
 */
export function getRouteName(route) {
  // 优先用 route.name（兼容保留的 SEO 静态路由）
  if (route.name && route.name !== 'algorithmDetail') {
    return route.name
  }
  // 动态路由从 path 末段查表
  const slug = route.params?.algorithmType || route.path.split('/').pop()
  return pathToKeyMap[slug] || slug
}
